<template>
    <div :class="{mb: isMobile}">
        <!-- Overseas Network -->
        <section class="overseas_network hover-anim" v-animate="'fade-in'">
            <div class="container border-bottom">
                <h5 class="sub_title">
                    <animation-sub-title :title="'中国独自のメディア “Baidu” “Weibo”への広告配信から“Google” “Facebook” “インフルエンサー”を利用した広告配信までオロの海外ネットワークで幅広く対応'" :id="'title-1'"/>
                </h5>
                <div class="img-area-with-scroll">
                    <div class="d-flex justify-content-between align-items-center img-area">
                        <div class="model client d-flex align-items-center"><img src="../../assets/global-ad/client.png" width="244" height="244"></div>
                        <i class="arrow-right"></i>
                        <div class="model global_team d-flex align-items-center"><img src="../../assets/global-ad/global_team.png" width="331" height="294.5"></div>
                        <i class="arrow-right"></i>
                        <div class="model sns d-flex align-items-center"><img src="../../assets/global-ad/sns.png" width="495" height="294"></div>
                    </div>
                </div>
                <p class="sub_content">中国人向け不動産投資、訪日インバウンド向け業種（航空会社、ホテル、レジャー施設、レンタカー）の企業向けにターゲット国に応じてメディア、<br/>
                    ユーザーの特徴を考慮した出稿をご提案いたします。</p>
            </div>
        </section>

        <!-- Target Visualization -->
        <section class="target_visualization hover-anim" v-animate="'fade-in'">
            <div class="container border-bottom">
                <h5 class="sub_title">
                    <animation-sub-title :title="'ターゲットの可視化'" :id="'title-2'"/>
                </h5>
                <div class="img-area">
                    <img class="target_visualization_1 sp-mb-25" src="../../assets/global-ad/target_visualization_1.jpg" width="509.76" height="372.5">
                    <img class="target_visualization_2" src="../../assets/global-ad/target_visualization_2.jpg" width="515" height="373">
                </div>
                <p class="sub_content">世界中のアクセス可能な調査データから各国、各地域の御社ターゲットボリューム調査とペルソナ設計を行い、コミュニケーションプランのコンセプト設計をします。</p>
            </div>
        </section>

        <!-- Competitive Investigation -->
        <section class="competitive_investigation hover-anim" v-animate="'fade-in'">
            <div class="container border-bottom">
                <h5 class="sub_title">
                    <animation-sub-title :title="'競合調査'" :id="'title-3'"/>
                </h5>
                <div class="img-area">
                    <img class="investigation_1 sp-mb-25" src="../../assets/global-ad/investigation_1.jpg" width="510.44" height="372.5">
                    <img class="investigation_2" src="../../assets/global-ad/investigation_2.jpg" width="514.5" height="372.5">
                </div>
                <p class="sub_content">競合調査においては競合企業の過去1年のSEOや入札キーワード状況、また各メディアにおいて配信しているクリエイティブを調査しメディアプランニングに移ります。</p>
            </div>
        </section>

        <!-- Budget Efficiency -->
        <section class="budget hover-anim" v-animate="'fade-in'">
            <div class="container border-bottom">
                <h5 class="sub_title">
                    <animation-sub-title :title="'予算効率の最大化'" :id="'title-4'"/>
                </h5>
                <div class="img-area-with-scroll">
                    <div class="img-area">
                        <img class="performance" src="../../assets/global-ad/performance.png" width="1227" height="539">
                    </div>
                </div>
                <p class="sub_content">原案の広告クリエイティブを作成した後にメディアや言語ごとの調整をすることで、プロジェクト管理費用や制作費用のコストを軽減できます。<br/>各メディアのパフォーマンスについても同一指標・同一フォーマットでご確認いただけます。</p>
            </div>
        </section>

        <!-- KPI -->
        <section class="kpi_design hover-anim" v-animate="'fade-in'">
            <div class="container">
                <h5 class="sub_title">
                    <animation-sub-title :title="'KPI設計'"  :id="'title-5'"/>
                </h5>
                <div class="img-area">
                    <img class="kpi_1 sp-mb-25" src="../../assets/global-ad/kpi_1.jpg" width="548" height="373">
                    <img class="kpi_1" src="../../assets/global-ad/kpi_2.jpg" width="542.69" height="373">
                </div>
                <p class="sub_content">御社の目標達成に向けてKPIの設定および見直し、KPI 達成に向けた測定方法をご提案いたします。</p>
            </div>
        </section>
    </div>
</template>

<script>
import AnimationSubTitle from "../common/AnimationSubTitle";
export default {
    name: 'GlobalAdContent',
    components: {AnimationSubTitle},
    computed: {
        isMobile() {
            if (window.innerWidth <= 768) return true;
            if ('maxTouchPoints' in navigator) return navigator.maxTouchPoints > 0 ? true : false
            else return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    },
}
</script>

<style lang="scss" scoped>
    .client {
        width: 17.7%;
        display: inline-block;
    }

    .overseas_network .model img {
        width: 100%;
    }

    .overseas_network {
        .img-area {
            margin: 85px 0;
            .model {
                img {
                    width: 100%;
                }
            }
        }
    }

    .global_team {
        width: 17.6%;
    }

    .sns {
        width: 35.9%;
    }

    .target_visualization {
        .target_visualization_1 {
            width: 48%;
            max-width: 509.76px;
        }

        .target_visualization_2 {
            width: 48%;
            max-width: 515px;
        }
    }

    .competitive_investigation {
        .investigation_1 {
            width: 48%;
            max-width: 510.44px;
        }

        .investigation_2 {
            width: 48%;
            max-width: 514.5px;
        }
    }

    .budget {
        .performance {
            width: 100%;
            max-width: 1227px;
        }
    }

    .kpi_design {
        .kpi_1 {
            width: 48%;
            max-width: 548px;
        }

        .kpi_2 {
            width: 48%;
            max-width: 542.69px;
        }
    }


    @media screen and (max-width: 767px) {
        .overseas_network {
            .img-area {
                margin: 30px 0;
            }
        }
        .img-area-with-scroll {
            overflow-x: auto;
            .img-area {
                width: 1364px;
            }
        }
        .competitive_investigation {
            .img-area-with-scroll {
                .img-area {
                    width: 1226px;
                }
            }
        }
    }
</style>
